import React from 'react';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import theme from './default/theme';

const appTheme = createMuiTheme({
  ...theme,
  overrides: {
    ...theme.overrides,
  },
});

export default function DefaultTheme(props) {
  return (
    <MuiThemeProvider theme={appTheme}>
      {/* eslint-disable-next-line react/prop-types */}
      {props.children}
    </MuiThemeProvider>
  );
}
